import { Form } from "antd"
import { RequiredMark } from "."
import { useForm } from "antd/lib/form/Form";
import { useEffect } from "react";

const FormAntd = ({
    form = null,
    initialValues = {},
    onFinish = () => { },
    colon = false,
    disabled = false,
    children,
    layout
},) => {
    const [formUse] = useForm(form);

    const handleOnFinish = () => {
        onFinish(formUse.getFieldsValue(true))
    }

    return <Form
        form={formUse}
        layout={layout}
        disabled={disabled}
        initialValues={{ ...initialValues }}
        onFinish={handleOnFinish}
        onFinishFailed={(e) => {
            console.log("e", e);
            formUse.getFieldInstance(e.errorFields?.[0]?.name?.at(0))?.focus({
                cursor: "start"
            })
        }}
        labelAlign={"left"}
        // scrollToFirstError={true}
        requiredMark={RequiredMark}
        colon={colon}
    >
        {children}
    </Form>

}

export default FormAntd